import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29d39456"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full border-t border-white bg-sand"
}
const _hoisted_2 = { class: "o-page-wrapper-gutter min-h-45 w-full text-white flex items-center justify-between" }
const _hoisted_3 = { class: "pr-30" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "impersonate" }, {
    default: _withCtx(() => [
      (_ctx.isImpersonating)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.impersonatedUserAccountName), 1),
              _createElementVNode("button", {
                class: "c-magic-line hover:text-white whitespace-nowrap",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.unImpersonate && _ctx.unImpersonate(...args)), ["prevent"]))
              }, _toDisplayString(_ctx.$dictionary.get('b2b/agent/exitimpersonationbuttontext')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}